import * as React from "react";
import { useLocation } from "react-router";
import { callHttpClientMethod } from "../../../../services/callHttpClient";
import { BASE_URL, HttpMethod } from "../../../../services/api.constant";
import { sizeDetail } from "../../../../services/apiList";
import { ProductSizes } from "../../../../gobalType";

export type SizeDetailState = (ProductSizes & {
  other_sizes?: { id: number; product_id: number; name: string }[];
  product_name?: string;
  images?: any[];
}) | undefined;

export function useSizeDetail() {
  const location = useLocation() as any;
  const [infoDetail, setInfoDetail] = React.useState<SizeDetailState>();
  const [loading, setLoading] = React.useState(false);

  const getSizeDetail = React.useCallback(async () => {
    setLoading(true);
    try {
      const data = {
        product_id: location.state?.product_id,
        size_id: location.state?.size_id,
      };
      const response = await callHttpClientMethod(
        BASE_URL + sizeDetail(),
        HttpMethod.Get,
        data,
        {}
      );
      setInfoDetail(response.data);
    } finally {
      setLoading(false);
    }
  }, [location.state?.product_id, location.state?.size_id]);

  React.useEffect(() => {
    getSizeDetail();
  }, [getSizeDetail]);

  return { infoDetail, loading, refresh: getSizeDetail };
}
